import { render } from "./WhatsAppConfig.vue?vue&type=template&id=a26da1b2"
import script from "./WhatsAppConfig.vue?vue&type=script&lang=js"
export * from "./WhatsAppConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../orangehrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__